import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";

import "../css/User.css";
import "../css/VoucherNumberSettingsTab.css";
import { Save } from "lucide-react";
import {
  Autocomplete,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

function AccountRegFormPopup(props) {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const [departmentFilterList, setDepartmentFilterList] = useState(null);
  const [departmentSearchText, setDepartmentSearchText] = useState("");

  const [departmentFilterListLink, setDepartmentFilterListLink] =
    useState(null);
  const [departmentSearchTextLink, setDepartmentSearchTextLink] = useState("");

  const [currencyListFiltered, setCurrencyListFiltered] = useState(null);
  const [currencySearchText, setCurrencySearchText] = useState("");

  const {
    setShowAccountRegForm,
    selectAccGroupRow,
    successfullyDone,
    accToEditAccountForm,
    setAccToEditAccountForm,
  } = props;
  console.log("Selected Group row from PROPS", selectAccGroupRow)
  const {
    data: datagetDetailOfAccountNumber,
    loading: loadinggetDetailOfAccountNumber,
    error: errorgetDetailOfAccountNumber,
    get: getDetailOfAccountNumber,
  } = useApi();
  const {
    data: datagetgetCurrencyList,
    loading: loadinggetCurrencyList,
    error: errorgetCurrencyList,
    get: getCurrencyList,
  } = useApi();
  const {
    data: datagetDepartmentList,
    loading: loadinggetDepartmentList,
    error: errorgetDepartmentList,
    get: getDepartmentList,
  } = useApi();
  const {
    data: datagetDuplicateCheckOnAcc,
    loading: loadinggetDuplicateCheckOnAcc,
    error: errorgetDuplicateCheckOnAcc,
    get: getDuplicateCheckOnAcc,
  } = useApi();

  const {
    data: datagetDuplicateCheckOnAccSubmit,
    loading: loadinggetDuplicateCheckOnAccSubmit,
    error: errorgetDuplicateCheckOnAccSubmit,
    get: getDuplicateCheckOnAccSubmit,
  } = useApi();

  const {
    data: getData,
    loading: getLoading,
    error: getError,
    get: getUsers,
  } = useApi();
  const {
    data: dataPostClone,
    loading: loadingPostClone,
    error: errorPostClone,
    post: postClone,
  } = useApi();
  const {
    data: datagetGLCategory,
    loading: loadinggetGLCategory,
    error: errorgetGLCategory,
    get: getGLCategory,
  } = useApi();

  const {
    data: datagetAcTypeNewNum,
    loading: loadinggetAcTypeNewNum,
    error: errorgetAcTypeNewNum,
    get: getAcTypeNewNum,
  } = useApi();

  const initialAccNumberArray = ["0", "0", "0", "0", "0", "0", "0", "0"];

  const [accNumberArray, setAccNumberArray] = useState(initialAccNumberArray);

  const [accGroupDescription, setAccGroupDescription] = useState("");

  const [glCategoryList, setGlCategoryList] = useState(null);

  const initialObjectDetails = {
    account_description: "",
    open_bal: "0",
    dept_no: "",
    link_dept: "",
    fc_open_bal: "0",
    fc: "",
    enable_delete: "",
    expense_type: "exclude",
    cost_center_req: false,
    budget_control: "0",
    dbt01: "",
    crd01: "",
    costc: "",
  };
  const [objectDetails, setObjectDetails] = useState(initialObjectDetails);

  useEffect(() => {
    if (datagetDepartmentList) {
      setDepartmentFilterList(datagetDepartmentList);
      setDepartmentFilterListLink(datagetDepartmentList);
    }
  }, [datagetDepartmentList]);

  useEffect(() => {
    if (datagetgetCurrencyList) {
      setCurrencyListFiltered(datagetgetCurrencyList);
    }
  }, [datagetgetCurrencyList]);

  useEffect(() => {
    if (datagetGLCategory) {
      setGlCategoryList(datagetGLCategory);
    }
  }, [datagetGLCategory]);

  const checkIfDuplicateAccNumber = (accNumberArrayPassed) => {
    let numberToCheck = accNumberArrayPassed.map((item) => item).join("");
    getDuplicateCheckOnAcc(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTCOUNT/-/-/-/${numberToCheck}`
    );
  };

  useEffect(() => {
    if (datagetDuplicateCheckOnAcc) {
      console.log("response of check duplicate", datagetDuplicateCheckOnAcc);

      if (datagetDuplicateCheckOnAcc[0]?.Column1 === 1) {
        alert("Account Number already exists");
        return;
      }
    }
  }, [datagetDuplicateCheckOnAcc]);

  const handleAccNumberChange = (e, indexOfTyped) => {
    console.log("e, indexOfTyped ", e, indexOfTyped);

    let newArray = accNumberArray?.map((item, index) => {
      if (indexOfTyped === index) {
        if (e.target.value > 9 || e.target.value < 0) {
          return item;
        } else {
          return e.target.value;
        }
      } else {
        return item;
      }
    });

    setAccNumberArray(newArray);
  };

  useEffect(() => {
    if (accNumberArray) {
      if (!accToEditAccountForm) {
        checkIfDuplicateAccNumber(accNumberArray);
      }
    }
  }, [accNumberArray]);

  useEffect(() => {
    if (datagetAcTypeNewNum) {
      if (!accToEditAccountForm) {
        setAccNumberArray(datagetAcTypeNewNum[0].Column1.split(""));
      }
    }
  }, [datagetAcTypeNewNum]);

  useEffect(() => {
    if (accToEditAccountForm) {
      console.log("accToEditAccountForm >>>>>>>.", accToEditAccountForm);

      let accountNumberToSearch = accToEditAccountForm?.ACCOUNT?.trim();
      setAccNumberArray(accToEditAccountForm?.ACCOUNT?.trim().split(""));
      getDetailOfAccountNumber(
        `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTINFO/-/-/-/${accountNumberToSearch}`
      );
    }
  }, [accToEditAccountForm]);

  useEffect(() => {
    if (datagetDetailOfAccountNumber) {
      let newObject = {
        ...datagetDetailOfAccountNumber[0],
        account_description: datagetDetailOfAccountNumber[0].accdesc,
        open_bal: datagetDetailOfAccountNumber[0].openbal + "",
        link_dept: datagetDetailOfAccountNumber[0].ipgrp,
        dept_no: datagetDetailOfAccountNumber[0].deptno,
        fc: datagetDetailOfAccountNumber[0].currency?.trim(),
        fc_open_bal: datagetDetailOfAccountNumber[0].curopenbal + "" || "0",
        expense_type:
          datagetDetailOfAccountNumber[0].QtnStat?.toLowerCase() || "exclude",
        cost_center_req:
          datagetDetailOfAccountNumber[0].InvStat === "Y" ||
          datagetDetailOfAccountNumber[0].InvStat === true ||
          false,
        budget_control:
          datagetDetailOfAccountNumber[0].RetnStat?.toString() || "0",
        dbt01: datagetDetailOfAccountNumber[0].dbt01?.trim() || "",
        crd01: datagetDetailOfAccountNumber[0].crd01?.trim() || "",
        costc: datagetDetailOfAccountNumber[0].costc?.trim() || "",
      };
      console.log("New object for autofilling", newObject);
      setObjectDetails(newObject);
      // setCurrencySearchText(datagetDetailOfAccountNumber[0]?.currency);
      // setDepartmentSearchText(datagetDetailOfAccountNumber[0]?.deptno);
      // setDepartmentSearchTextLink(datagetDetailOfAccountNumber[0]?.ipgrp);
    }
  }, [datagetDetailOfAccountNumber]);

  useEffect(() => {
    console.log("useEffect on []");

    //here pass 1 as dynamic ie Assset 2 liability 2 etc

    let numberToPass = selectAccGroupRow.TYPE;

    getAcTypeNewNum(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTNEWNUM/${numberToPass}/-/-/-`
    );
    getUsers(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`
    );

    getDepartmentList(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`
    );
    getCurrencyList(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/CURRENCY/-/-`
    );
    getGLCategory(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/GLCATEGORY/-/-/${DEPARTMENT}/-`
    );
  }, []);

  const callAPI = (modeTopass) => {
    if (accToEditAccountForm) {
      modeTopass = "M";
    }

    if (objectDetails.account_description?.trim()?.length === 0) {
      alert("Please enter description");
      return;
    }

    let numberToCheck = accNumberArray.map((item) => item).join("");

    getDuplicateCheckOnAccSubmit(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTCOUNT/-/-/-/${numberToCheck}`
    )
      .then((res) => {
        console.log("res ==", res.data);

        if (res.data[0]?.Column1 != 1) {
          let arraytoPass = [
            {
              CmpCode: COMPANY_CODE,
              mode: "I",
              account: accNumberArray.map((item) => item).join(""),
              accdesc: objectDetails.account_description,
              acctype: selectAccGroupRow.TYPE,
              currency: objectDetails.fc || "AED",
              openbal:
                objectDetails.open_bal?.trim() === ""
                  ? 0
                  : objectDetails.open_bal,
              startbal: 0.0,
              debit: 0.0,
              credit: 0.0,
              dbt01: objectDetails.dbt01 || "",
              crd01: objectDetails.crd01 || "",
              dbt02: "",
              crd02: "",
              dbt03: 0.0,
              crd03: 0.0,
              dbt04: 0.0,
              crd04: 0.0,
              dbt05: 0.0,
              crd05: 0.0,
              dbt06: 0,
              crd06: 0.0,
              dbt07: 0.0,
              crd07: 0.0,
              dbt08: 0.0,
              crd08: 0.0,
              dbt09: 0.0,
              crd09: 0.0,
              dbt10: 0.0,
              crd10: 0.0,
              dbt11: 0.0,
              crd11: 0.0,
              dbt12: 0.0,
              crd12: 0.0,
              dbt13: 0.0,
              crd13: 0.0,
              op00: 0.0,
              debit00: 0,
              credit00: 0,
              dbt: 0.0,
              crd: 0.0,
              bal01: 0.0,
              bal02: 0.0,
              bal03: 0.0,
              bal04: 0.0,
              bal05: 0.0,
              bal06: 0.0,
              bal07: 0.0,
              bal08: 0.0,
              bal09: 0.0,
              bal10: 0.0,
              bal11: 0.0,
              bal12: 0.0,
              climit: 0.0,
              curcrlimit: 0.0,
              currencyno: "",
              curopenbal: 0.0,
              ipgrp: objectDetails.link_dept?.trim(),
              deptno: objectDetails.dept_no?.trim(),
              terms: "",
              depn_p: 0,
              sale_man: "",
              area_code: "",
              country: "",
              jan: 0.0,
              feb: 0.0,
              mar: 0.0,
              apr: 0.0,
              may: 0.0,
              jun: 0.0,
              jul: 0.0,
              aug: 0.0,
              sep: 0.0,
              oct: 0.0,
              nov: 0.0,
              dec: 0.0,
              duedays: 0,
              costc: objectDetails.costc || "",
              commp: 0.0,
              alias: "",
              date: "2025-08-26T00:00:00",
              hide: "",
              discount: 0.0,
              locn: "",
              PRICEGRP: "",
              ctype: "",
              CREDITMETHOD: "",
              vattype: "",
              TRN: "",
              lattitude: "",
              longitude: "",
              project: "",
              createdate: "2025-08-26T00:00:00",
              autoid: 0,
              GPSCorditate: "",
              PriWhatsapp: "",
              OtWhatsapp: "",
              QtnStat: objectDetails.expense_type || "exclude", //Expense Type
              InvStat: objectDetails.cost_center_req ? "Y" : "N", //cost center req
              RetnStat: objectDetails.budget_control || "0", //Budget Control
              UserTrn: "",
              UseForDel: "",
              CustType: "",
              patron: "",
              patrontype: "",
              officenumber: "",
              regno: "",
              dumpfield: "",
            },
          ];

          let serialize = JSON.stringify(arraytoPass);

          console.log("arraytoPass>>. ++++", arraytoPass);

          //confirm this url is correct ie controller
          postClone(
            `https://cubixweberp.com:213/api/CRMAccountReg`,
            serialize,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } else if (res.data[0]?.Column1 === 1 && accToEditAccountForm) {
          let arraytoPass = [
            {
              CmpCode: COMPANY_CODE,
              mode: modeTopass,
              account: accNumberArray.map((item) => item).join(""),
              accdesc: objectDetails.account_description,
              acctype: selectAccGroupRow.TYPE,
              currency: objectDetails.fc ? objectDetails.fc : "AED",
              openbal:
                objectDetails.open_bal?.trim() === ""
                  ? 0
                  : objectDetails.open_bal,
              startbal: 0.0,
              debit: 0.0,
              credit: 0.0,
              dbt01: objectDetails.dbt01 || "",
              crd01: objectDetails.crd01 || "",
              dbt02: "",
              crd02: "",
              dbt03: 0.0,
              crd03: 0.0,
              dbt04: 0.0,
              crd04: 0.0,
              dbt05: 0.0,
              crd05: 0.0,
              dbt06: 0,
              crd06: 0.0,
              dbt07: 0.0,
              crd07: 0.0,
              dbt08: 0.0,
              crd08: 0.0,
              dbt09: 0.0,
              crd09: 0.0,
              dbt10: 0.0,
              crd10: 0.0,
              dbt11: 0.0,
              crd11: 0.0,
              dbt12: 0.0,
              crd12: 0.0,
              dbt13: 0.0,
              crd13: 0.0,
              op00: 0.0,
              debit00: 0,
              credit00: 0,
              dbt: 0.0,
              crd: 0.0,
              bal01: 0.0,
              bal02: 0.0,
              bal03: 0.0,
              bal04: 0.0,
              bal05: 0.0,
              bal06: 0.0,
              bal07: 0.0,
              bal08: 0.0,
              bal09: 0.0,
              bal10: 0.0,
              bal11: 0.0,
              bal12: 0.0,
              climit: 0.0,
              curcrlimit: 0.0,
              currencyno: "",
              curopenbal: 0.0,
              ipgrp: objectDetails.link_dept?.trim(),
              deptno: objectDetails.dept_no?.trim(),
              terms: "",
              depn_p: 0,
              sale_man: "",
              area_code: "",
              country: "",
              jan: 0.0,
              feb: 0.0,
              mar: 0.0,
              apr: 0.0,
              may: 0.0,
              jun: 0.0,
              jul: 0.0,
              aug: 0.0,
              sep: 0.0,
              oct: 0.0,
              nov: 0.0,
              dec: 0.0,
              duedays: 0,
              costc: objectDetails.costc || "",
              commp: 0.0,
              alias: "",
              date: "2025-08-26T00:00:00",
              hide: "",
              discount: 0.0,
              locn: "",
              PRICEGRP: "",
              ctype: "",
              CREDITMETHOD: "",
              vattype: "",
              TRN: "",
              lattitude: "",
              longitude: "",
              project: "",
              createdate: "2025-08-26T00:00:00",
              autoid: 0,
              GPSCorditate: "",
              PriWhatsapp: "",
              OtWhatsapp: "",
              QtnStat: objectDetails.expense_type || "exclude", //Expense Type
              InvStat: objectDetails.cost_center_req ? "Y" : "N", //cost center req
              RetnStat: objectDetails.budget_control || "0", //Budget Control
              UserTrn: "",
              UseForDel: "",
              CustType: "",
              patron: "",
              patrontype: "",
              officenumber: "",
              regno: "",
              dumpfield: "",
            },
          ];

          let serialize = JSON.stringify(arraytoPass);

          console.log("arraytoPass>>.edit mode ", arraytoPass);

          postClone(
            `https://cubixweberp.com:213/api/CRMAccountReg`,
            serialize,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } else {
          alert("Account Number already exists");
        }
      })
      .catch((err) => { });
  };

  useEffect(() => {
    if (dataPostClone) {
      if (dataPostClone?.result?.trim()?.toUpperCase() === "SAVED") {
        setAccNumberArray(initialAccNumberArray);
        setAccGroupDescription("");
        // Reset form state
        setAccNumberArray(initialAccNumberArray);
        setAccGroupDescription("");
        setObjectDetails(initialObjectDetails);

        // Close the Account Registration modal
        setShowAccountRegForm(false);
        setAccToEditAccountForm(null);
        successfullyDone();
      }
    }
  }, [dataPostClone]);

  const cancelledPopup = () => {
    console.log("cancelledPopup ", initialAccNumberArray);
    setShowAccountRegForm((prev) => !prev);
    setAccNumberArray(initialAccNumberArray);
    setAccGroupDescription("");
    setAccToEditAccountForm(null);
  };

  const handleInputChange = (e) => {
    let newArray = { ...objectDetails, [e.target.name]: e.target.value };
    setObjectDetails(newArray);
  };

  const intercompanyCategoryList = glCategoryList?.filter(
    (item) => item.CATEGORY === "INTERCOMPANY"
  ) || [];

  const isIntercompany = intercompanyCategoryList?.some(
    (item) => item.LIST?.trim() === selectAccGroupRow?.TYPE?.trim()
  );

  return (
    <div className="bg-slate-50 rounded-lg shadow-sm overflow-hidden">
      <style>{`
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
    input[type=number] { -moz-appearance: textfield; }
    .custom-autocomplete .MuiOutlinedInput-root {
      padding: 2px 9px !important;
      height: 36px;
      background-color: white; /* Keep inputs white for contrast */
    }
  `}</style>

      <div className="p-5 space-y-4">
        {/* Row 1: Account Code & Description */}
        <div className="grid grid-cols-2 gap-4 items-end">
          <div className="shrink-0">
            <label className="text-[10px] font-semibold text-gray-400 block mb-1">
              Account Code
            </label>
            <div className="flex gap-1">
              {accToEditAccountForm
                ? accToEditAccountForm.ACCOUNT?.trim()
                  .split("")
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`w-8 h-9 flex items-center justify-center border rounded font-mono font-semibold ${index === 0
                        ? "bg-slate-800 text-white border-slate-800"
                        : "bg-white text-slate-600 border-slate-200"
                        }`}
                    >
                      {item}
                    </div>
                  ))
                : accNumberArray?.map((item, index) => (
                  <input
                    key={index}
                    type="number"
                    disabled={index === 0}
                    value={accNumberArray[index]}
                    onChange={(e) => handleAccNumberChange(e, index)}
                    className={`w-8 h-9 text-center border rounded font-mono font-semibold outline-none ${index === 0
                      ? "bg-slate-800 text-white border-slate-800"
                      : "bg-white border-slate-300 focus:border-[#009688]"
                      }`}
                  />
                ))}
            </div>
          </div>
          <div className="flex-1">
            <label className="text-[10px] font-semibold text-gray-400 tracking-widest block mb-1">
              Description <span className="text-red-500">*</span>
            </label>
            <input
              name="account_description"
              onChange={handleInputChange}
              value={objectDetails.account_description}
              className="w-full border border-slate-200 rounded px-3 h-9 text-sm focus:border-[#009688] outline-none bg-white"
              placeholder="Enter account name..."
            />
          </div>
        </div>

        {/* Row 2: Department & Link Dept (MUI Autocomplete) */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-[10px] font-semibold text-gray-400  block mb-1">
              Dept No
            </label>
            <Autocomplete
              className="custom-autocomplete"
              options={departmentFilterList || []}
              getOptionLabel={(option) => option.deptnodesc || ""}
              value={
                departmentFilterList?.find(
                  (d) => d.deptno?.trim() === objectDetails.dept_no?.trim()
                ) || null
              }
              onChange={(event, newValue) => {
                setObjectDetails({
                  ...objectDetails,
                  dept_no: newValue ? newValue.deptno?.trim() : "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Dept..."
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      fontSize: "13px",
                      "& fieldset": { borderColor: "#e2e8f0" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#009688 !important",
                      },
                    },
                  }}
                />
              )}
            />
          </div>

          <div>
            <label className="text-[10px] font-semibold text-gray-400  block mb-1">
              Link Dept
            </label>
            <Autocomplete
              className="custom-autocomplete"
              options={departmentFilterListLink || []}
              getOptionLabel={(option) => option.deptnodesc || ""}
              value={
                departmentFilterListLink?.find(
                  (d) => d.deptno?.trim() === objectDetails.link_dept
                ) || null
              }
              onChange={(event, newValue) => {
                setObjectDetails({
                  ...objectDetails,
                  link_dept: newValue ? newValue.deptno?.trim() : "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Link Dept..."
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      fontSize: "13px",
                      "& fieldset": { borderColor: "#e2e8f0" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#009688 !important",
                      },
                    },
                  }}
                />
              )}
            />
          </div>
        </div>

        {/* Row 3: Balances & Currency */}
        <div className="grid grid-cols-3 gap-4">
          <div>
            <div className="flex items-center justify-between">
              <label className="text-[10px] font-semibold text-gray-400  block mb-1">
                Opening Bal
              </label>
              <span className="text-[10px] font-semibold text-gray-400  block mb-1">
                View
              </span>
            </div>
            <input
              name="open_bal"
              type="number"
              onChange={handleInputChange}
              value={objectDetails.open_bal}
              className="w-full border border-slate-200 rounded px-3 h-9 text-sm outline-none focus:border-[#009688]"
            />
          </div>
          <div>
            <label className="text-[10px] font-semibold text-gray-400  block mb-1">
              FC Currency
            </label>
            <Autocomplete
              className="custom-autocomplete"
              options={currencyListFiltered || []}
              getOptionLabel={(option) => option.cur || ""}
              value={
                currencyListFiltered?.find(
                  (c) => c.curno?.trim() === objectDetails.fc
                ) || null
              }
              onChange={(event, newValue) => {
                setObjectDetails({
                  ...objectDetails,
                  fc: newValue ? newValue.curno?.trim() : "",
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      fontSize: "13px",
                      "& fieldset": { borderColor: "#e2e8f0" },
                      "&.Mui-focused fieldset": {
                        borderColor: "#009688 !important",
                      },
                    },
                  }}
                />
              )}
            />
          </div>
          <div>
            <label className="text-[10px] font-semibold text-gray-400  block mb-1">
              FC Open Bal
            </label>
            <input
              name="fc_open_bal"
              type="number"
              onChange={handleInputChange}
              value={objectDetails.fc_open_bal}
              className="w-full border border-slate-200 rounded px-3 h-9 text-sm outline-none focus:border-[#009688]"
            />
          </div>
        </div>

        {/* Row 4: Expense Settings */}
        <div className="bg-white p-3 rounded-lg border border-slate-200 shadow-sm flex items-center justify-between gap-6">
          <div className="w-[40%]">
            <label className="text-[10px] font-semibold text-slate-500 block mb-1.5">
              Classification
            </label>
            <div className="flex bg-slate-100 border border-slate-200 rounded p-0.5">
              {["Exclude", "Controlled", "Variable"].map((type) => (
                <label key={type} className="flex-1 cursor-pointer">
                  <input
                    type="radio"
                    name="expense_type"
                    className="sr-only"
                    value={type.toLowerCase()}
                    onChange={handleInputChange}
                    // If objectDetails.expense_type is empty/null, it defaults to checking 'exclude'
                    checked={
                      objectDetails.expense_type === type.toLowerCase() ||
                      (!objectDetails.expense_type && type === "Exclude")
                    }
                  />
                  <div
                    className={`text-center py-1 rounded text-[10px] font-semibold transition-all ${objectDetails.expense_type === type.toLowerCase() ||
                      (!objectDetails.expense_type && type === "Exclude")
                      ? "bg-[#009688] text-white shadow-sm"
                      : "text-gray-400"
                      }`}
                  >
                    {type}
                  </div>
                </label>
              ))}
            </div>
          </div>
          <div className="flex items-center gap-2 mt-4">
            <button
              type="button"
              onClick={() =>
                setObjectDetails({
                  ...objectDetails,
                  cost_center_req: !objectDetails.cost_center_req,
                })
              }
              className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${objectDetails.cost_center_req ? "bg-[#009688]" : "bg-slate-300"
                }`}
            >
              <span
                className={`${objectDetails.cost_center_req
                  ? "translate-x-5"
                  : "translate-x-1"
                  } inline-block h-3 w-3 transform rounded-full bg-white transition`}
              />
            </button>
            <span className="text-[11px] font-semibold text-slate-600">
              Cost Center Required
            </span>
          </div>
          <div className="flex-1">
            <label className="text-[10px] font-semibold text-slate-500  block mb-1">
              Budget Control
            </label>
            <FormControl fullWidth size="small">
              <Select
                value={objectDetails.budget_control || "0"}
                onChange={(e) =>
                  setObjectDetails({
                    ...objectDetails,
                    budget_control: e.target.value,
                  })
                }
                sx={{
                  height: "28px",
                  fontSize: "11px",
                  backgroundColor: "white",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#e2e8f0",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#009688",
                  },
                }}
              >
                <MenuItem value="0" sx={{ fontSize: "11px" }}>
                  No Control
                </MenuItem>
                <MenuItem value="1" sx={{ fontSize: "11px" }}>
                  Warn Only
                </MenuItem>
                <MenuItem value="2" sx={{ fontSize: "11px" }}>
                  Block
                </MenuItem>
              </Select>
            </FormControl>
          </div>{" "}
        </div>

        {isIntercompany && (
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="text-[10px] font-semibold text-gray-400 block mb-1">
                Debit
              </label>
              <input
                name="dbt01"
                value={objectDetails.dbt01}
                onChange={handleInputChange}
                className="w-full border border-slate-200 rounded px-3 h-9 text-sm focus:border-[#009688] outline-none bg-white"
                placeholder="Enter debit account..."
              />
            </div>
            <div>
              <label className="text-[10px] font-semibold text-gray-400 block mb-1">
                Credit
              </label>
              <input
                name="crd01"
                value={objectDetails.crd01}
                onChange={handleInputChange}
                className="w-full border border-slate-200 rounded px-3 h-9 text-sm focus:border-[#009688] outline-none bg-white"
                placeholder="Enter credit account..."
              />
            </div>
            <div>
              <label className="text-[10px] font-semibold text-gray-400 block mb-1">
                Intercompany Department
              </label>
              <input
                name="costc"
                value={objectDetails.costc}
                onChange={handleInputChange}
                className="w-full border border-slate-200 rounded px-3 h-9 text-sm focus:border-[#009688] outline-none bg-white"
                placeholder="Enter intercompany dept..."
              />
            </div>
          </div>
        )}
      </div>

      {/* Footer: Changed bg-slate-50 to bg-slate-100 for more depth */}
      <div className="bg-slate-100 px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
        <button
          className="px-4 py-1.5 text-sm text-slate-500 hover:text-slate-800 font-semibold"
          onClick={cancelledPopup}
        >
          Cancel
        </button>
        <button
          className="flex items-center gap-2 px-6 py-1.5 rounded bg-[#009688] text-white hover:bg-[#00796b] text-sm font-semibold shadow-md"
          onClick={() => callAPI("I")}
        >
          <Save className="w-4 h-4" /> Save Account
        </button>
      </div>
    </div>
  );
}

export default AccountRegFormPopup;
